/* collection-showcase — IO fade-up reveal + scroll-snap arrow controls.
   Scroll is pure CSS scroll-snap; JS only drives the arrows (disabled at each
   end and when there's no overflow, e.g. 4-up fills the row on desktop) and the
   entrance reveal. Reduced-motion / no-IO → reveal immediately, instant scroll. */
(function () {
  var roots = document.querySelectorAll('[data-cs-root]');
  if (!roots.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window);

  roots.forEach(function (root) {
    /* entrance */
    if (reduce) {
      root.classList.add('collection-showcase--in');
    } else {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) { if (e.isIntersecting) { root.classList.add('collection-showcase--in'); obs.disconnect(); } });
      }, { threshold: 0.12 });
      io.observe(root);
    }

    /* arrows */
    var track = root.querySelector('[data-cs-track]');
    var arrows = root.querySelector('[data-cs-arrows]');
    if (!track || !arrows) return;
    var prev = root.querySelector('[data-cs-prev]');
    var next = root.querySelector('[data-cs-next]');

    function step() {
      var item = track.querySelector('.cshow__item');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
      return item ? item.getBoundingClientRect().width + gap : Math.round(track.clientWidth * 0.8);
    }
    function update() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      var x = track.scrollLeft;
      if (prev) prev.disabled = !overflow || x <= 2;
      if (next) next.disabled = !overflow || x + track.clientWidth >= track.scrollWidth - 2;
    }
    var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: behavior }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
